(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('PerfilFlotaFormController', PerfilFlotaFormController);
    

    PerfilFlotaFormController.$inject = [
		'$stateParams',
		'genericDataService',
        'perfilFlotaService',
        '$q',
        '$state',
        'notificationService'
    ];

	function PerfilFlotaFormController(
        $stateParams, 
        genericDataService, 
        perfilFlotaService, 
        $q, 
        $state, 
        notificationService){

		/* PRIVATE VARIABLES */
		var id = $stateParams.id;

		/* PUBLIC VARIABLES */
        var vm = this;

        vm.perfil = {};

        vm.data = {
            bases: {
                list: [],
                source: {
                    list: [],
                    selected: {}
                },
                perfil: {
                    list: [],
                    selected: {}
                }
            },
            flota: {
                list: [],
                source: {
                    list: [],
                    selected: {}
                },
                perfil: {
                    list: [],
                    selected: {}
                }
            },
            operarios: {
                list: [],
                source: {
                    list: [],
                    selected: {}
                },
                perfil: {
                    list: [],
                    selected: {}
                }
            }
        };
        
        /* FUNCTIONS */
        vm.toggleSelect = toggleSelect;
        vm.unselectAll = unselectAll;
        vm.moveFrom = moveFrom;
        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.goToList = goToList;

        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

		/* INITIALIZER */
		(function () {
            var promises = [];

            promises.push(getGenericData());
			
            if (id != null) {//Edit
                vm.isNew = false;
				promises.push(perfilFlotaService.getById(id).then(function(res){
                    vm.perfil = res.data;
                }));
			} else{
                vm.isNew = true;
            }
            
            $q.all(promises).then(function(){ //Everything is loaded
                initializeLists();
            });
		})();


        /* FUNCTIONS */
        function toggleSelect(element, type){
            if(type.selected[element.id]){
                type.selected[element.id] = undefined;
            } else {
                type.selected[element.id] = true;
            }

            var selected = type.selected;
            vm.unselectAll(vm.data.bases.source);
            vm.unselectAll(vm.data.bases.perfil);
            vm.unselectAll(vm.data.flota.source);
            vm.unselectAll(vm.data.flota.perfil);
            vm.unselectAll(vm.data.operarios.source);
            vm.unselectAll(vm.data.operarios.perfil);
            type.selected = selected;
        }

        function unselectAll(type){
            type.selected = {};
        }

        function moveFrom(from){
            switch(from){
                case vm.data.bases.source: 
                    moveSelected(vm.data.bases.source, vm.data.bases.perfil, vm.data.bases); 
                    break;
                case vm.data.bases.perfil: 
                    moveSelected(vm.data.bases.perfil, vm.data.bases.source, vm.data.bases); 
                    break;
                case vm.data.flota.source: 
                    moveSelected(vm.data.flota.source, vm.data.flota.perfil, vm.data.flota); 
                    break;
                case vm.data.flota.perfil: 
                    moveSelected(vm.data.flota.perfil, vm.data.flota.source, vm.data.flota); 
                    break;
                case vm.data.operarios.source: 
                    moveSelected(vm.data.operarios.source, vm.data.operarios.perfil, vm.data.operarios); 
                    break;
                case vm.data.operarios.perfil:
                    moveSelected(vm.data.operarios.perfil, vm.data.operarios.source, vm.data.operarios); 
                    break;
            }
        }

        function save(){
            doSave().then(function(res){
                if(vm.isNew){
                    $state.go('flota.perfilflota.editar', { 'id': res.data });
                }
            });
        }

        function saveAndClose(){
            doSave().then(function(res){
                vm.goToList();
            });
        }

        function saveAndNew(){
            doSave().then(function(res){
                if (vm.isNew) {
					$state.reload();
				} else {
					$state.go('flota.perfilflota.nuevo');
				}
            });
        }

        function goToList() {
			$state.go('flota.perfilflota.listado');
		}

        /* PRIVATE FUNCTIONS */
        function getGenericData(){
            var promises = [];

            vm.data.bases.loading = true;
			promises.push(genericDataService.getBases()
				.then(function (res) {
					vm.data.bases.loading = false;
					vm.data.bases.list = res;
                })
            );
                
            vm.data.operarios.loading = true;
            promises.push(genericDataService.getOperarios()
                .then(function (res) {
                    vm.data.operarios.loading = false;
                    vm.data.operarios.list = res;
                })
            );

            vm.data.flota.loading = true;
            promises.push(genericDataService.getFlota()
                .then(function (res) {
                    vm.data.flota.loading = false;
                    vm.data.flota.list = res;
                })
            );
            
            return $q.all(promises);
        }

        function doSave(){
            var deferred = $q.defer();
            
            var operarioIds = '', baseIds = '', flotaIds = '';

            vm.data.bases.perfil.list.forEach(function(element){
                baseIds += element.id + ',';
            });
            baseIds = baseIds.slice(0, -1);
            vm.data.flota.perfil.list.forEach(function(element){
                flotaIds += element.id + ',';
            });
            flotaIds = flotaIds.slice(0, -1);
            vm.data.operarios.perfil.list.forEach(function(element){
                operarioIds += element.id + ',';
            });
            operarioIds = operarioIds.slice(0, -1);

            vm.perfil.operarioIds = operarioIds;
            vm.perfil.baseIds = baseIds;
            vm.perfil.flotaIds = flotaIds;

            if(vm.isNew){
                perfilFlotaService.add(vm.perfil).then(function(res){
                    notificationService.sendAppNotification({
                        message: 'Perfil creado con éxito',
                        positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                    });
                    deferred.resolve(res);
                }, function(res){
                    notificationService.sendAppNotification({
                        message: 'Ha ocurrido un error al crear el perfil',
                        positionY: 'top', positionX: 'right', delay: null, type: 'error'
                    });
                    deferred.reject(res);
                });
            } else {
                perfilFlotaService.update(vm.perfil).then(function(res){
                    notificationService.sendAppNotification({
                        message: 'Perfil modificado con éxito',
                        positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                    });
                    deferred.resolve(res);
                }, function(res){
                    notificationService.sendAppNotification({
                        message: 'Ha ocurrido un error al modificar el perfil',
                        positionY: 'top', positionX: 'right', delay: null, type: 'error'
                    });
                    deferred.reject(res);
                });
            }

            return deferred.promise;
        }

        function initializeLists(){
            vm.data.bases.source.list = vm.data.bases.list;
            vm.data.flota.source.list = vm.data.flota.list;
            vm.data.operarios.source.list = vm.data.operarios.list;

            if(!vm.isNew){
                vm.perfil.baseIds.toLowerCase().split(',').forEach(function(element) {
                    vm.data.bases.source.selected[element] = true;
                });
                vm.perfil.flotaIds.toLowerCase().split(',').forEach(function(element) {
                    vm.data.flota.source.selected[element] = true;
                });
                vm.perfil.operarioIds.toLowerCase().split(',').forEach(function(element) {
                    vm.data.operarios.source.selected[element] = true;
                });
            }

            moveSelected(vm.data.bases.source, vm.data.bases.perfil, vm.data.bases);
            moveSelected(vm.data.flota.source, vm.data.flota.perfil, vm.data.flota);
            moveSelected(vm.data.operarios.source, vm.data.operarios.perfil, vm.data.operarios);
        }

        function moveSelected (from, to, data){
            var fromList = [], toList = [];

            for(var i = 0; i < data.list.length; i++){
                var element = data.list[i];
                if(indexOf(to.list, function(el){ return el.id === element.id; }) === -1 && 
                !from.selected[element.id]){
                    fromList.push(element);
                } else {
                    toList.push(element);
                }
            }

            from.list = fromList;
            to.list = toList;
        }

        function indexOf(array, checkFnc){
            for(var i = 0; i < array.length; i++){
                if(checkFnc(array[i])){ return i; }
            }
            return -1;
        }

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if(!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

    }

})();
